import React from 'react';

import { Wrapper } from './wrapper';

export interface IContent {
  article?: boolean;
  children?: React.ReactNode;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  fontSize?: 'current' | 'small';
  fullWidth?: boolean;
  size?: 'small';
  tone?: 'main' | 'alt';
  center?: boolean;
}

const Content = ({
  article,
  children,
  tone,
  fontSize,
  fullWidth,
  dangerouslySetInnerHTML,
  center,
}: IContent) => {
  if (dangerouslySetInnerHTML) {
    return (
      <Wrapper
        $tone={tone}
        $fontSize={fontSize}
        $fullWidth={fullWidth}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        $article={article}
        $center={center}
      />
    );
  }
  return (
    <Wrapper $tone={tone} $fontSize={fontSize} $fullWidth={fullWidth} $center={center}>
      {children}
    </Wrapper>
  );
};

export default Content;
